module.exports = "/_next/static/images/502-cf5259cb24742da903ba8d622f3b2852.png";